/* Generated by scripts/build-picker-icons.mjs. Do not edit directly. */
import type { PickerIconProps } from "../types.ts";

export function SymbolSpaIcon({
  size = 24,
  color = "currentColor",
  title,
  ...svgProps
}: PickerIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      data-icon="symbol-spa"
      data-variant="filled"
      role={title ? "img" : undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...svgProps}
    >
      {title ? <title>{title}</title> : null}
      <path d="M9.8 23.02Q6.6 22.2 4.25 19.76Q1.9 17.32 1.23 13.47Q1.15 13.05 1.26 12.69Q1.38 12.32 1.63 12.05Q1.88 11.78 2.23 11.63Q2.58 11.47 3 11.53Q7.4 11.93 9.53 14.59Q11.65 17.25 11.8 21.38Q11.82 21.8 11.66 22.15Q11.5 22.5 11.22 22.73Q10.95 22.95 10.57 23.04Q10.2 23.13 9.8 23.02ZM12 13.38Q11.15 12.25 9.91 11.32Q8.68 10.4 7.5 9.9Q7.58 8.72 8.47 6.6Q9.38 4.47 10.75 2.52Q11 2.17 11.32 2.01Q11.65 1.85 12 1.85Q12.35 1.85 12.69 2.01Q13.03 2.17 13.25 2.52Q14.63 4.47 15.54 6.6Q16.45 8.72 16.5 9.9Q15.35 10.38 14.1 11.31Q12.85 12.25 12 13.38ZM14.5 22.98Q14.53 21.3 14.29 19.48Q14.05 17.65 13.47 16.07Q14.35 14.47 16.2 13.13Q18.05 11.78 21.02 11.5Q21.45 11.45 21.8 11.6Q22.15 11.75 22.4 12.03Q22.65 12.3 22.75 12.66Q22.85 13.03 22.77 13.45Q22.05 17.43 19.84 19.76Q17.63 22.1 14.5 22.98Z" fill={color} />
    </svg>
  );
}
